import { Button } from "@mui/material";
import React from "react";
import { NavLink } from "react-router-dom";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    borderTopLeftRadius: theme.spacing(1),
    borderTopRightRadius: theme.spacing(1),
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    border: "1px solid var(--primary)",

    fontWeight: "800",
    width: "100%",
    overflow: "hidden",
    minWidth: 100,
    padding: "0.25rem 1rem",
  },
}));

const TabsLink = ({ id, items, className }) => {
  const classes = useStyles();
  return (
    <div className={["absolute inset-x-0", className].join(' ')}>
      <div className="flex items-end border-b border-primary gap-2 w-full overflow-y-auto">
        {items
          .filter((item) => item.permission)
          .map((item) =>
            item.disabled ? (
              <div key={`${id}-${item.id}`} className="min-w-100px text-nowrap opacity-50 cursor-not-allowed">
                <Button
                  variant="contained"
                  color={"secondary"}
                  className={classes.root}
                  style={{
                    border: "1px solid var(--muted-foreground)",
                    cursor: "not-allowed",
                    pointerEvents: "none",
                    color: "var(--muted-foreground)"
                  }}
                >
                  {item.name}
                </Button>
              </div>
            ) : (
              <NavLink
                key={`${id}-${item.id}`}
                to={item.path}
                end={item.end}
                className="min-w-100px text-nowrap"
                disabled={item.disabled}
              >
                {({ isActive }) => (
                  <Button
                    variant="contained"
                    color={isActive ? "primary" : "secondary"}
                    className={classes.root}
                    style={{
                      borderBottom: isActive
                        ? "1px solid var(--primary)"
                        : "none",
                    }}
                    disabled={item.disabled}
                  >
                    {item.name}
                  </Button>
                )}
              </NavLink>
            )
          )}
      </div>
    </div>
  );
};

export default TabsLink;
